<template>
    <div class="row">
        <div class="col-sm-9">
            <div class="step-detail step-two">

            </div>
        </div>

        <div class="col-sm-3">
            <div class="your-selection col-sm-12">
                <div class="block title">
                    <p>Uw selectie</p>
                </div>
                <div class="block">
                    <p>{{StepOne}}</p>
                </div>

                <div class="block">
                    <div class="prices">
                        <div class="line" v-for="price in prices">
                            <div>{{price.name}}</div>
                            <div>&euro; {{price.value}}</div>
                        </div>
                    </div>
                </div>

                <div class="block total">
                    <p>Total</p>
                    <p>&euro; {{total}}</p>
                </div>
                <router-link to="/stepthree">
                    <button class="btn primary icon check">
                        Okee, ga verder
                    </button>
                </router-link>
                <!--<button class="btn primary icon check">-->
                <!--Okee, ga verder-->
                <!--</button>-->
            </div>
        </div>
    </div>
</template>

<script>
  import Checkbox from '../components/elements/Checkbox'
  import SquareCheckbox from '../components/elements/SquareCheckbox'
  import Between from '../components/elements/Between'
  import ProductOverviewItem from '../components/elements/ProductOverviewItem'
  import InfoCheck from '../components/elements/InfoCheck'
  import InfoRadios from '../components/elements/InfoRadios'
  import InfoRadio from '../components/elements/InfoRadio'
  import Vue from 'vue'
  import { EventBus} from '../services/eventBus'
  import apiService from '../services/request'
  import Filter from '../components/elements/Filter';

  export default {
    name: 'StepOne',
    components: {
      'checkbox': Checkbox,
      'square-checkbox': SquareCheckbox,
      'between': Between,
      'product-overview-item': ProductOverviewItem,
      'info-check': InfoCheck,
      'info-radio': InfoRadio,
      'info-radios': InfoRadios,
      'filter-item': Filter
    },
    data () {
      return {
        total: '',
        StepOne: '',
        prices: [{name: 'ONE 24 FDCU', value: 113.15}, {name: 'IXI R1', value: 23.15}, {name: 'FDCU', value: 428.95}],
        filters: [
          {
            filtergroup: "afmetingen",
            open: true,
            filters: [
              {
                type: "checkbox",
                group: "shapes",
                options: [
                  {
                    value: "Rechthoekig",
                    checked: false
                  },
                  {
                    value: "Rond",
                    checked: false
                  }
                ]
              },
              {
                type: "between",
                group: "dimensies",
                options: [
                  {
                    value: "Breedte (mm)",
                    min: "100",
                    max: "1500"
                  },
                  {
                    value: "Hoogte (mm)",
                    min: "100",
                    max: "1500"
                  },
                  {
                    value: "Diameter (mm)",
                    min: "100",
                    max: "1500"
                  }
                ]
              }
            ]
          },
          {
            filtergroup: "brandweerstand",
            open: false,
            filters: [
              {
                type: "singleInput",
                group: "brandweerstand",
                option: [
                  {
                    value: "Mininmale brandweerstand (in minuten)",
                    input: "0"
                  }
                ]
              },
              {
                type: "multicheck",
                grouxp: "wandtypes",
                options: [
                  {
                    value: "Flexibele wand",
                    checked: false,
                    img: "http://via.placeholder.com/125x125/ffffff/000000"
                  },
                  {
                    value: "Massive wand",
                    checked: false,
                    img: "http://via.placeholder.com/125x125/ffffff/000000"
                  },
                  {
                    value: "Blokken wand",
                    checked: false,
                    img: "http://via.placeholder.com/125x125/ffffff/000000"
                  },
                  {
                    value: "Massieve vloer",
                    checked: false,
                    img: "http://via.placeholder.com/125x125/ffffff/000000"
                  }
                ]
              }
            ]
          }
        ],
        mechanismes: [
          {
            name: 'Smeltlood mechanisme',
            picture: '/static/img/smeltlood-mechanisme.3d274d9.png',
            mechanisme: [
              {
                name: 'Automatisch ontgrendelingsmechanisme',
                id: '20',
                price: '75.22',
                type: 'checkbox',
                info: 'hier vind je info',
                omschrijving: 'Automatische ontgrendeling',
                picture: '/static/images/automatisch-ontgrendelingsmechanisme.png',
                options: [
                  {
                    id: '20',
                    price: '75.22',
                    type: 'checkbox',
                    name: 'Contracten',
                    info: 'hier vind je meer info',
                    omschrijving: 'meer info over contacten'
                  }
                ]
              }
            ]
          },
          {
            name: 'Gemotoriseerd mechanisme',
            picture: '/static/img/gemotoriseerd-mechanisme.a8bc6b2.png',
            mechanisme: [
              {
                name: 'Op afstand bediende veerteruggangsmotor (ONE)',
                id: '20',
                price: '75.22',
                type: 'radio',
                omschrijving: 'Geschikt voor alle afmetingen',
                picture: 'http://via.placeholder.com/75x75',
                models: [
                  {
                    name: '24V',
                    options: [
                      {
                        value: 'Stecker (ONE 24 FDCU)',
                        info: 'dit is informatie'
                      },
                      {
                        value: 'Unipolaire schakelaar (ONE 24 FDCU)',
                        info: 'dit is informatie'
                      },
                      {
                        value: 'Bipolaire schakelaar (ONE 24 FDCU)',
                        info: 'dit is informatie'
                      }
                    ]
                  },
                  {
                    name: '230V',
                    options: [
                      {
                        value: 'Stecker (ONE 24 FDCU)',
                        info: 'dit is informatie'
                      },
                      {
                        value: 'Unipolaire schakelaar (ONE 24 FDCU)',
                        info: 'dit is informatie'
                      },
                      {
                        value: 'Bipolaire schakelaar (ONE 24 FDCU)',
                        info: 'dit is informatie'
                      }
                    ]
                  }
                ],
                options: [
                  {
                    name: 'Options',
                    type: 'radio',
                    options: [
                      {
                        info: 'hier vind je meer info',
                        value: 'IXI-R1',
                        text: 'Universele veldcontroller (Modbus, BACnet of analoge aansluiting), voorgemonteerd op de klep.',
                        price: '213,20'
                      },
                      {
                        info: 'hier vind je meer info',
                        value: 'IXI-R2 24V',
                        text: 'Universele veldcontroller (Modbus, BACnet), voorgemonteerd op de klep, met aansluiting voor een 2de brandklep.',
                        price: '213,20'

                      },
                      {
                        info: 'hier vind je meer info',
                        value: 'IXI-R2 230V',
                        text: 'Universele veldcontroller (Modbus, BACnet), voorgemonteerd op de klep, met aansluiting voor een 2de brandklep.',
                        price: '213,20'
                      }
                    ]
                  }
                ]
              },
              {
                name: 'Op afstand bediende veerteruggangsmotor (BFL(T))',
                id: '20',
                price: '75.22',
                type: 'radio',
                omschrijving: 'Enkel geschikt voor kleinere afmetingen',
                picture: 'http://via.placeholder.com/75x75',
                models: [
                  {
                    name: '24V',
                    options: [
                      {
                        value: 'Stecker (ONE 24 FDCU)',
                        info: 'dit is informatie'
                      },
                      {
                        value: 'Thermische zekering (ONE 24 FDCU)',
                        info: 'dit is informatie'
                      }
                    ]
                  },
                  {
                    name: '230V',
                    options: [
                      {
                        value: 'Stecker (ONE 24 FDCU)',
                        info: 'dit is informatie'
                      },
                      {
                        value: 'Thermische zekering (ONE 24 FDCU)',
                        info: 'dit is informatie'
                      }
                    ]
                  }
                ],
                options: [
                  {
                    id: '20',
                    price: '83,31',
                    type: 'checkbox',
                    name: 'SN2 BFL/BFN',
                    info: 'hier vind je meer info',
                    omschrijving: 'Bipolaire eindeloop- en beginloopschakelaar'
                  }
                ]
              }
            ]
          }
        ]
      }
    },
    methods: {
      setPrices () {
        Vue.ls.set('StepTwo', this.prices)
      },
      getMechanisms () {
        apiService.getMechanisms(this.setMechanisms)
      },
      setMechanisms (response) {
        console.log(response)
      },
      finalise () {
        // Vue.ls.set('StepTwo', this.prices)
      },
      getTotal () {
        console.log(this.prices)
        for (let i = 0; i < this.prices.length; i++) {
          console.log(this.prices[i].value)
          let price = this.prices[i].value
          let total = this.total
          this.total = (+total + +price)
          console.log(this.total)
        }
      }
    },
    mounted: function () {
      console.log(Vue.ls.get('StepOne'))
      if(Vue.ls.get('StepOne') === null) {
        this.$router.push({name: 'StepOne'})
      }
      EventBus.$emit('routeChange')

      this.getTotal()
      this.setPrices()
      this.StepOne = Vue.ls.get('StepOne')
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/Playground.vue